import { Button, ButtonStyles, IconButton, Icons, Label, TextInput } from '@silverfort/sf-components';

const ServicePicker = ({ serviceName, onServiceNameChange, onSave, onClose }) => {
    return (
        <div className="w-full absolute top-0 left-[276px]">
            <div className={'bg-sf-white w-[272px] h-[208px] shadow-sf-medium border border-sf-gray-100 rounded-lg'}>
                <div className="flex border-b px-4 border-sf-gray-100 justify-between items-center h-14">
                    <Label text={'Add service'} />
                    <IconButton onClick={() => onClose()} icon={Icons.Cancel} />
                </div>
                <div className="flex flex-col border-b py-4 px-6 gap-2 border-sf-gray-100 justify-center h-24">
                    <Label text="Name" mandatory={true} />
                    <TextInput
                        className="h-10 w-full"
                        value={serviceName}
                        onChange={(val) => onServiceNameChange(val)}
                    />
                </div>
                <div className="flex border-b px-4 gap-1 border-sf-gray-100 justify-end items-center h-14">
                    <Button text="Cancel" buttonStyle={ButtonStyles.Tertiary} onClick={() => onClose()} />
                    <Button text="Save" onClick={() => onSave()} disabled={!serviceName} />
                </div>
            </div>
        </div>
    );
};

export default ServicePicker;
